enum ObservationCustomComponentType {
    COMBO = 0,
    DATE = 1,
}

export default ObservationCustomComponentType;